





























import Vue from "vue";
import FormatMoney from "@/components/FormatMoney";
Vue.component("FormatMoney", FormatMoney);

export default Vue.extend({
  name: "StatementItemDetailsTableItem",
  props: {
    title: { type: String, required: true },
    gross: { type: Number },
    net: { type: Number, required: true },
    dotColor: { type: String },
    bold: { type: Boolean },
    forceShowGross: { type: Boolean },
  },
});
